import { render, staticRenderFns } from "./VariantSifterSessionParamBubbles.vue?vue&type=template&id=027c76e8&scoped=true&"
import script from "./VariantSifterSessionParamBubbles.vue?vue&type=script&lang=js&"
export * from "./VariantSifterSessionParamBubbles.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterSessionParamBubbles.vue?vue&type=style&index=0&id=027c76e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027c76e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('027c76e8')) {
      api.createRecord('027c76e8', component.options)
    } else {
      api.reload('027c76e8', component.options)
    }
    module.hot.accept("./VariantSifterSessionParamBubbles.vue?vue&type=template&id=027c76e8&scoped=true&", function () {
      api.rerender('027c76e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterSessionParamBubbles.vue"
export default component.exports